import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import CupoyRouter from "components/commons/router/CupoyRouter";
import CupoySrefView from "components/commons/router/CupoySrefView";

class PrizedInvoiceListItem extends PureComponent {

    static propTypes = {
        item: PropTypes.object.isRequired,
        index: PropTypes.number,
    };

    render() {
        const {
            index,
            item,
        } = this.props;

        return (            
            <tr className="table-list-row">
                <td className="table-list-col" style={{width: '60px'}}>
                    {index}.
                </td>
                <td className="table-list-col link">

                    {item.detail && item.detail.hasNoRecord ?
                        item.invoicenumber
                        :
                        null
                    }

                    {item.detail && !item.detail.hasNoRecord ?
                        <CupoySrefView
                            statename={CupoyRouter.STATES.INVOICE_INFO}
                            params={{
                                yearmonth: item.yearmonth,
                                istarttag: item.istarttag,
                                invoicenumber: item.invoicenumber,
                            }}
                        >
                            {item.invoicenumber}
                        </CupoySrefView>
                        :
                        null
                    }

                    {!item.detail ?
                        item.invoicenumber
                        :
                        null
                    }
                </td>
                <td className="table-list-col">
                    {item.yearmonth}
                </td>
                <td className="table-list-col">
                    {item.istarttag}
                </td>
            </tr>
        );
    }
}

export default PrizedInvoiceListItem;



// WEBPACK FOOTER //
// ./src/components/prizecheck/PrizedInvoiceListItem.jsx